export default "__VITE_ASSET__CTuUPaRa__"